// CreateNewPassword.js
import React, { useState } from 'react';
import '../styles/CreateNewPassword.css'; // Ensure you have appropriate CSS
import { baseUrl } from '../config';
import SEO from '../components/SEO';



const CreateNewPassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [passwordValidationError, setPasswordValidationError] = useState('');

  const validatePassword = (password) => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{10,}$/;
    return regex.test(password);
  };

  const handleNewPasswordChange = (e) => {
    const newPassword = e.target.value;
    setNewPassword(newPassword);
    if (!validatePassword(newPassword)) {
      setPasswordValidationError(
        'Password must be at least 10 characters long, include 1 uppercase letter, 1 special character, 1 lowercase letter, and 1 number.'
      );
    } else {
      setPasswordValidationError('');
    }
    validatePasswordMatch(newPassword, confirmNewPassword);
  };

  const handleConfirmNewPasswordChange = (e) => {
    const newConfirmPassword = e.target.value;
    setConfirmNewPassword(newConfirmPassword);
    validatePasswordMatch(newPassword, newConfirmPassword);
  };

  const validatePasswordMatch = (newPassword, confirmNewPassword) => {
    if (newPassword !== confirmNewPassword) {
      setPasswordError('Passwords do not match');
    } else {
      setPasswordError('');
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Perform API call to update the password
    if (!passwordError && !passwordValidationError) {
      // Redirect to login or show success message
    }
  };

  return (
    <div className="create-password-container">
      <SEO
        title="Create New Password"
        description="Create a new password for your ProducerBuddy account."
        url="https://producerbuddy.pilomation.com/create-password"
        robots="noindex, nofollow"
      />
      <h2>Create New Password</h2>
      <form onSubmit={handleSubmit} className="create-password-form">
        <div className="form-group">
          <label className="required">New Password</label>
          <input
            type="password"
            value={newPassword}
            onChange={handleNewPasswordChange}
            required
          />
          {passwordValidationError && <p className="error-text">{passwordValidationError}</p>}
        </div>

        <div className="form-group">
          <label className="required">Confirm New Password</label>
          <input
            type="password"
            value={confirmNewPassword}
            onChange={handleConfirmNewPasswordChange}
            required
          />
          {passwordError && <p className="error-text">{passwordError}</p>}
        </div>

        <button type="submit" className="create-password-button">
          Reset Password
        </button>
      </form>
    </div>
  );
};

export default CreateNewPassword;

